const getApiUrl = () => {
  if (
    window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV)
  ) {
    return process.env.REACT_APP_DEV_API_URL;
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)) {
    return process.env.REACT_APP_TEST_API_URL;
  }
  return process.env.REACT_APP_PROD_API_URL;
};
export default getApiUrl;
